import { CATEGORY_ACTIONS } from '../actions/categoriesAction'

const INITIAL_STATE = {
  grades: undefined
}

const CategoriesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CATEGORY_ACTIONS.SET_CATEGORIES:
      return {
        ...state,
        ...action.payload
      }
    default:
      return state
  }
}

export default CategoriesReducer
